import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { Tab, Tabs } from '@dbk/ui-tabs';
import { NavigationListItemHeader, NavigationListItem } from '@dbk/ui-list';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import styles from './reports-positions-downloads.style';
import { PALETTE, DE } from '../../../constants';
import format from 'date-fns/format';
import TableRow from '../../../../../../src/components/common/table-row';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import { formatDate } from '../report-utils';

class PositionsDownload extends PureComponent {


  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      downloadType: '',
      currentTab: 0
    };
    this.callDirectExcelService = this.callDirectExcelService.bind(this);
  }



  positionDownloads() {
    const { i18n: { messages },
      auth: {documentDownloadDisabled} } = this.props;

    return (

      <div className='btn-change-reports-container' align='right' style={{ marginTop: "30px" }}>
        <Button
          testID="btn_positionReport_reportPositionsDownloads_test"
          size='large'
          disabled = {documentDownloadDisabled}
          tertiary = {documentDownloadDisabled}
          loading={!!this.state.isLoading}
          onClick={() => this.callDirectExcelService('Positions')}
        >{messages['app.downloads.download']}
        </Button>
      </div>



    );
  }

  JSONToCSV(JSONData, ReportTitle) {
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    let CSV = '';
    var row = '';
    for (const index1 in arrData.sections) {
      CSV += arrData.sections[index1].name + '\r\n\n';
      CSV += arrData.sections[index1].description + '\r\n\n';

      for (var index in arrData.sections[index1].headers) {
        row += arrData.sections[index1].headers[index] + ',';
      }
      row = row.slice(0, -1);
      CSV += row + '\r\n';
      for (let i = 0; i < arrData.sections[index1].results.length; i++) {
        var row = '';
        for (var index in arrData.sections[index1].results[i]) {
          row += '"' + arrData.sections[index1].results[i][index] + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
      }
    }
    if (CSV == '') {
      alert('Invalid data');
      return;
    }
    if (ReportTitle == 'Positions') {
      ReportTitle = 'Portfolios';
    }
    let fileName = '';
    fileName += ReportTitle.replace(/ /g, '_');

    const uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
    const anchor = document.createElement('a');
    anchor.href = uri;

    anchor.style = 'visibility:hidden';
    anchor.download = fileName + '.csv';

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  createXmlHeader(arrData) {
    let headerRow = '<ss:Row>\n';
    let dataRow = '';

    for (const preRow in arrData.sections) {
      dataRow +=
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].name +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n' +
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].description +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n';
      for (const index in arrData.sections[preRow].headers) {
        headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
        headerRow += '    <ss:Data ss:Type="String">';
        headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
        headerRow += '  </ss:Cell >\n';
      }
    }

    headerRow += '</ss:Row>\n';
    return (
      '<?xml version="1.0"?>\n' +
      '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
      '<ss:Styles>\n' +
      '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
      '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
      '<ss:Borders>\n' +
      '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '</ss:Borders>\n' +
      '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
      '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
      '</ss:Style>\n' +
      '</ss:Styles>\n' +
      '<ss:Worksheet ss:Name="Sheet1">\n' +
      '<ss:Table>\n' +
      dataRow +
      '<ss:Row/>\n' +
      headerRow
    );
  }

  createXmlFooter() {
    return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
  }

  jsonToXml(jsonObject) {
    let row;
    var col;
    let xml;
    const arrData =
      typeof jsonObject !== 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = this.createXmlHeader(arrData);

    for (const rowData in arrData.sections) {
      for (
        let resultsLength = 0;
        resultsLength < arrData.sections[rowData].results.length;
        resultsLength++
      ) {
        xml += '<ss:Row>\n';
        for (var col in arrData.sections[rowData].results[resultsLength]) {
          xml += '  <ss:Cell>\n';
          xml += '    <ss:Data ss:Type="String">';
          xml +=
            arrData.sections[rowData].results[resultsLength][col] +
            '</ss:Data>\n';
          xml += '  </ss:Cell>\n';
        }
        xml += '</ss:Row>\n';
      }
    }
    xml += this.createXmlFooter();
    return xml;
  }

  excelDownload(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    const anchor = document.createElement('a');
    const blob = new Blob([content], {
      type: contentType,
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
      anchor.download = filename;
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reports.custom.downloads.result != nextProps.reports.custom.downloads.result) {
      const result = nextProps.reports.custom.downloads.result;
      this.excelDownload(
        this.jsonToXml(result),
        result.sheetname ? result.sheetname : this.state.downloadType + '.xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      this.setState({ isLoading: false });
    }
  }
  callDirectExcelService(trxType) {
    this.setState({ isLoading: true });
    const {
      settings: { currentEnvironment: { remoteUrl } },
      // downloads: { startDate, endDate },
      reports: { custom: { extract: { downloads: { startDate, endDate } } } },
      selectedPortfolioData,
      i18n: { messages },
    } = this.props;
    this.setState({ downloadType: trxType });
    this.props
      .downLoadReport({
        reportname: trxType,
        fromDate: startDate,
        toDate: endDate,
      })
      .then((success) => {
        this.setState({ isLoading: false });
      }).catch((error) => {
        this.setState({ isLoading: false });
      });;
  }

  render() {
    const { profile, auth, i18n: { messages } } = this.props;
    const { auth: { langCode, documentDownloadDisabled } } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };
    const { isLoading } = this.state;

    const receivedDate = formatDate(new Date(), langCode);


    auth.resetInfoMessage();
    return (
      <div>
        <View style={{ marginLeft: 20, marginRight: 20 }}>
          <Tabs
            stretch
            secondary
            selectedIndex={this.state.currentTab}>
            <Tab style={{ fontSize: 16, paddingHorizontal: 0 }} testID="tab_positionReport_reportsPositionsDownloads_test"
              renderLabel={() => messages['app.chedelivery.reports.downloadPositionsReport']} />
          </Tabs>
        </View>

        <SortingHeader
          enabled={false}
          showBorder={false}
          messages={messages}
        />
        <div style={{ marginLeft: 20, marginRight: 20 }}>
        <NavigationListItem testID="list_positionReport_reportsPositionsDownloads_test" inverse selected='true' hasArrow={false} style={{ height: 90, paddingBottom: 5 }} onClick={documentDownloadDisabled? null:() => this.callDirectExcelService('Positions')}>
            <View style={{ flexDirection: 'row', width: '100%' }}>
              <View style={{ width: '70%' }}>
                <NavigationListItemHeader>
                  <Large numberOfLines={2}
                    ellipsizeMode={'tail'}
                    className="rowHeader">
                    {messages['app.chedelivery.reports.customReports.positions'] + ' ' + receivedDate}
                  </Large>
                </NavigationListItemHeader>
              </View>
              <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '22%' }}>
                <Large style={{ color: '#a7a8aa' }}>
                  {receivedDate}
                </Large>
              </View>
            </View>
          </NavigationListItem>
          <div>
            {this.positionDownloads()}
          </div>
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    this.props.clearDownloadDates();
  }
}

PositionsDownload.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  downloads: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
  settings: PropTypes.shape({
    currentEnvironment: PropTypes.shape({
      remoteUrl: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    userId: PropTypes.string,
    authHeader: PropTypes.string,
    lastSession: PropTypes.string,
  }),
  app: PropTypes.shape({
    user: PropTypes.shape({
      selectedPortfolioData: PropTypes.string,
    }),
  }),
  rsa: PropTypes.shape({
    rsaAuthorised: PropTypes.bool,
  }),
};

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      downloads: {
        calendar: {
          open: {
            $call: 'open',
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        isDateBarClickable: true,
        setFalse: { $set: 'isDateBarClickable' },
        setStartDateEmpty: { $set: 'startDate' },
        setEndDateEmpty: { $set: 'endDate' },
        downLoadReport: { $call: 'excelData' },
        result: true,
      },
      reports: {
        custom: {
          extract: {
            downloads: {
              startDate: true,
              endDate: true
            }
          },
          downloads: {
            result: true
          }
        },
        trans: {
          calendar: {
            open: {
              $call: 'open'
            },
            ...CalendarModal.getFragment('calendarModal'),
          },
          startDate: true,
          endDate: true,
          dateDisplay: true,
          transactionHistoryList: true,
          isLoading: true,
        },
      },
      downLoadReport: { $call: 'reports.custom.downloads.excelData' },
      resetDownloadDates: { $call: 'downloads.resetDates' },
      clearDownloadDates: { $call: 'downloads.clearDates' },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      settings: {
        currentEnvironment: {
          remoteUrl: true,
        },
      },
      rsaChangePage: { $call: 'rsa.changePage' },
      auth: {
        userId: true,
        resetInfoMessage: { $call: 'resetInfoMessage' },
        lastSession: true,
        authHeader: true,
        langCode: true,
        documentDownloadDisabled:true,
      },
      app: {
        user: {
          selectedPortfolioData: true,
        },
      },
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
    },
  },
  ({ app, ...queries }) => ({
    selectedPortfolioData: app.user.selectedPortfolioData,
    ...queries,
  })
)(PositionsDownload);

export { PositionsDownload };
